import { Directive, EventEmitter, OnDestroy, Output, TemplateRef, ViewContainerRef } from '@angular/core';
import { BusyService } from 'app/core/services';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[busy]',
})
export class BusyDirective implements OnDestroy {
  private hasView = false;
  private unsubscribeAll = new Subject<void>();

  constructor(templateRef: TemplateRef<any>, viewContainer: ViewContainerRef, busyService: BusyService) {
    busyService.busyState$
      .pipe(
        map((busyState) => busyState.isBusy),
        takeUntil(this.unsubscribeAll)
      )
      .subscribe((isBusy) => {
        if (this.showView(isBusy) && !this.hasView) {
          viewContainer.createEmbeddedView(templateRef);
          this.hasView = true;
        } else if (!this.showView(isBusy) && this.hasView) {
          viewContainer.clear();
          this.hasView = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  protected showView(isBusy: boolean): boolean {
    return isBusy;
  }
}

@Directive({
  selector: '[notBusy]',
})
export class NotBusyDirective extends BusyDirective {
  constructor(templateRef: TemplateRef<any>, viewContainer: ViewContainerRef, busyService: BusyService) {
    super(templateRef, viewContainer, busyService);
  }

  showView(isBusy: boolean): boolean {
    return !isBusy;
  }
}

@Directive({
  selector: '[disableWhileBusy]',
})
export class DisableWhileBusyDirective implements OnDestroy {
  @Output() enable = new EventEmitter<void>();
  @Output() disable = new EventEmitter<void>();

  private unsubscribeAll = new Subject<void>();

  constructor(busyService: BusyService) {
    busyService.busyState$
      .pipe(
        map((busyState) => busyState.isBusy),
        takeUntil(this.unsubscribeAll)
      )
      .subscribe((isBusy) => {
        if (isBusy) {
          this.disable.emit();
        } else {
          this.enable.emit();
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
